import userService from '@/services/user.service';
import config from '@/config/prod.env';
import  router from '@/router/index.js';

const actions = {
    // getByUsername({dispatch, commit}, {username}){
    //     return new Promise((resolve, reject) => {
    //         // Do something here... lets say, a http call using vue-resource
    //         userService.getByUsername(username).then(response => {
    //             // http success, call the mutator and change something in state
    //             resolve(response);  // Let the calling function know that http is done. You may send some data back
    //         }, error => {
    //             // http failed, let the calling function know that action did not work out
    //             reject(error);
    //         })
    //     })
    // },

    // async isExistUsername({dispatch, commit}, username) {
    //     let res = await userService.isExistUsername(username);
    //     return res.data;
    // },

    // async getAllPagingUser({ dispatch }, params) {
    //     return await userService.getAllPaging(params);
    // },
    
    // async createUser({ dispatch, commit }, user) {
    //     let res = await userService.create(user);
    //     if(res.isOk) {
    //         if(res.data && res.data.data.id && res.data.data.id.trim().length > 0) {
    //             dispatch("alert/success", "Thêm mới thành công", { root: true });
    //             return true;
    //         } else {
    //             dispatch("alert/error", res.data.message, { root: true });
    //             return false;
    //         }
    //     } else {
    //         dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
    //         return false;
    //     }
    // },

    // async updateUser({ dispatch, commit }, user) {
    //     let res = await userService.update(user);
    //     if(res.isOk) {
    //         if(res.data.data) {
    //             dispatch("alert/success", "Cập nhật thành công", { root: true });
    //             return true;
    //         } else {
    //             dispatch("alert/error", res.data.message, { root: true });
    //             return false;
    //         }
    //     } else {
    //         dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
    //         return false;
    //     }
    // },

    async updateProfile({ dispatch, commit }, user) {
        let res = await userService.updateProfile(user);
        if(res.isOk) {
            if(res.data.success) {
                dispatch("alert/success", "Cập nhật thành công", { root: true });
                
                let userStored = JSON.parse(localStorage.getItem('user_profile'));
                userStored.hoTen = user.hoTen;
                userStored.gioiTinh = user.gioiTinh;
                userStored.email = user.email;
                userStored.sdt = user.sdt;
                commit('updateProfile', userStored);
                localStorage.setItem('user_profile', JSON.stringify(userStored));
                
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    // async deleteUser({ dispatch, commit }, id) {
    //     let res = await userService.delete(id);
    //     if(res.isOk) {
    //         if(res.data.data) {
    //             dispatch("alert/success", "Xóa thành công", { root: true });
    //             return true;
    //         } else {
    //             dispatch("alert/error", res.data.message, { root: true });
    //             return false;
    //         }
    //     } else {
    //         dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
    //         return false;
    //     }
    // },

    // async deleteManyUser({ dispatch, commit }, ids) {
    //     let res = await userService.deleteMany(ids);
    //     if(res.isOk) {
    //         if(res.data.data) {
    //             dispatch("alert/success", `Đã xóa ${res.data.data} dòng`, { root: true });
    //             return true;
    //         } else {
    //             dispatch("alert/error", res.data.message, { root: true });
    //             return false;
    //         }
    //     } else {
    //         dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
    //         return false;
    //     }
    // },

    async changePass({ dispatch, commit }, model) {
        let res = await userService.changePass(model.password, model.passwordNew, model.passwordNewConfirmed);
        if(res.isOk) {
            if(res.data.success) {
                dispatch("alert/success", "Thay đổi mật khẩu thành công", { root: true });

                setTimeout(() => {
                    router.push({ path: '/logout' });
                }, 1000);
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    // async resetPass({ dispatch, commit }, model) {
    //     let res = await userService.resetPass(model.id, model.newPass);
    //     if(res.isOk) {
    //         if(res.data.data) {
    //             dispatch("alert/success", "Reset mật khẩu thành công", { root: true });
    //             return true;
    //         } else {
    //             dispatch("alert/error", res.data.message, { root: true });
    //             return false;
    //         }
    //     } else {
    //         dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
    //         return false;
    //     }
    // },


};

const mutations = {
    updateProfile(state, user) {
        state.user = user;
    },
};

export const user = {
    namespaced: true,
    actions,
    mutations
};